import { render, staticRenderFns } from "./DefinitionParameterInput.vue?vue&type=template&id=06c94d2f&scoped=true"
import script from "./DefinitionParameterInput.vue?vue&type=script&lang=js"
export * from "./DefinitionParameterInput.vue?vue&type=script&lang=js"
import style0 from "./DefinitionParameterInput.vue?vue&type=style&index=0&id=06c94d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c94d2f",
  null
  
)

export default component.exports